import { APIGet } from '../services/API'


export const getEpisodes = (seriesId,type,limit) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_EPISODES',
        payload: {
            ui: "loading"
        }
    });

    let url;
    let queryString;
    let qs = [];

    if(type === 'pco'){
        url = site + '/api/v1/pco/channel';
        if(seriesId) qs.push('channel='+seriesId);
    } else {
        url = site+'/api/v1/podcasts/full';
        if(seriesId) qs.push('series='+seriesId);
    }

    if(limit) qs.push('limit='+limit);


    // Set String    
    queryString = qs.join('&');
    url += '?'+queryString;
    

    // Send Request To Get Events
    APIGet(url)
    .then(res => res.json())
    .then(json => {
        dispatch({ type: 'GET_EPISODES_SUCCESS',payload: {ui:"success",podcast:json}});
    })
    .catch(e => {
        dispatch({ type: 'GET_EPISODES_ERROR',payload: {ui:"error",message:e}});
    })

}


